import { IonButton, IonCard, IonCardContent, IonCol, IonContent, IonIcon, IonPage, IonRow, IonText } from '@ionic/react';
import { calendarOutline, chatbubbleOutline, folderOutline } from 'ionicons/icons';
import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { Link } from 'react-router-dom';

import LoadingContainer from '../../components/loading/LoadingContainer';
import HR from '../../layouts/HR';
import Toolbar2 from '../../layouts/Toolbar2';
import { isHome } from '../../library/Funcs';
import { BlogViewAction } from '../../redux/actions/Blog';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Description from './Description';

import './BlogPage.css';
import LayoutGap from '../../layouts/LayoutGap';
import Slideshow from '../../components/slideshow/Slideshow';

interface Props extends RouteComponentProps<{
  blog_id: string
}> { }

const BlogPage: React.FC<Props> = ({ match }) => {
  const dispatch = useAppDispatch()
  const singleBlogView = useAppSelector(state => state.blogView)
  const { loading, blogView } = singleBlogView

  useEffect(() => {
    dispatch(BlogViewAction(match.params.blog_id));

    return () => {
      if (isHome()) {
        dispatch({ type: 'BLOG_VIEW_RESET' })
      }
    }
  }, [dispatch])

  let source = "";
  if (blogView.post?.source_name.length > 0) {
    source = "<br/>منبع : <a target='_blank' href='" + blogView.post?.source_link + "'>" + blogView.post?.source_name + "</a>";
  }

  const toolbarButtons = <React.Fragment>
    <Link to={{ pathname: `${match.params.blog_id}/comments`, state: blogView.post?.comments_list }}>
      <IonButton shape="round" color="white">
        <IonIcon icon={chatbubbleOutline} />
      </IonButton>
    </Link>
  </React.Fragment>

  return <LoadingContainer loading={loading}>
    <IonPage className="blog">
      <Toolbar2 title="وبلاگ" endButtons={toolbarButtons} hasBackButton hasShadow />

      <LayoutGap />

      <IonCard className="main-content">
        <IonContent>
          <IonCardContent>
            <IonRow>
              <IonCol>
                <IonText className="title">{blogView.post?.title}</IonText>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol size="6">
                <IonText className="category"><IonIcon src={folderOutline} />{blogView.post?.category}</IonText>
              </IonCol>
              <IonCol size="6" className="ion-text-left">
                <IonText className="date"><div>{blogView.post?.date}<IonIcon src={calendarOutline} /></div></IonText>
              </IonCol>
            </IonRow>
            <HR />
            <IonRow>
              <IonCol>
                <div className="image" style={{ backgroundImage: 'url(' + blogView.post?.image + ')' }}></div>
              </IonCol>
            </IonRow>
            <IonRow>
              <IonCol>
                <Description content={blogView.post?.content + source}></Description>
              </IonCol>
            </IonRow>
          </IonCardContent>
        </IonContent>
      </IonCard>
    </IonPage>
  </LoadingContainer>
}

export default BlogPage